import React, { useRef, useState, useEffect } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { PlayArrow, Pause } from "@mui/icons-material";

export const ShareVideoPlayer = ({ src, onError }) => {
  const videoRef = useRef(null);
  const playerRef = useRef(null); // Reference for the player container
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [showButton, setShowButton] = useState(true); // Button visibility state

  const handleError = () => {
    setHasError(true);
    setIsPlaying(false);
    if (onError) onError();
  };

  const togglePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
        setShowButton(true); // Show play button when video is paused
      } else {
        videoRef.current.play().catch((err) => {
          console.error("Error playing video:", err);
        });
        setShowButton(false); // Hide button when video starts playing
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleBoxClick = () => {
    if (isPlaying) {
      videoRef.current.pause();
      setIsPlaying(false);
      setShowButton(true); // Show pause button when video is paused
    }
  };
  // Reload the video when the `src` changes, but do not play it automatically
  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      video.setAttribute("src", src);
      video.load(); // Reload the video

      // manual trigger mouse down action
      video
        .play()
        .then(() => {
          setIsPlaying(true); // Ensure the video is in a paused state
          setShowButton(false); // Show the play button
        })
        .catch((err) => {
          setIsPlaying(false); // Ensure the video is in a paused state
          setShowButton(true); // Show the play button
        });
    }
  }, [src]);

  return (
    <Box
      ref={playerRef} // Reference to the player container
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        width: "100vw",
        height: "100vh",
        background: "black",
        position: "relative",
      }}
      onClick={handleBoxClick} // Pause video when box is clicked
    >
      {!hasError ? (
        <>
          <video
            onContextMenu={(e) => e.preventDefault()}
            x-webkit-airplay="allow"
            airplay="allow"
            ref={videoRef}
            width="100%"
            height="100%"
            onError={handleError}
            style={{
              background: "black",
              objectFit: "contain",
            }}
          />
          {/* Play/Pause Button */}
          {showButton && (
            <IconButton
              onClick={togglePlayPause}
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                color: "white",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.7)",
                },
              }}
            >
              {isPlaying ? (
                <Pause fontSize="large" />
              ) : (
                <PlayArrow fontSize="large" />
              )}
            </IconButton>
          )}
        </>
      ) : (
        <Typography color="red">Error loading video</Typography>
      )}
    </Box>
  );
};
